<template>
  <div
    v-if="defaultPartnerPromoCode"
    v-html="defaultPromoCodeText"
  />
  <div
    v-else-if="configs.special_discount_percentage"
    v-html="$t('label.special_discount', { discount: configs.special_discount_percentage })"
  />
  <div v-else>
    <q-toggle
      v-model="showPromoCodeInput"
      class="toggle-margin"
      :label="$t('transfer.have_promo_code')"
      @update:modelValue="$emit('show-promo-code-input', $event)"
    />
    <q-slide-transition appear>
      <PromoCode
        v-if="showPromoCodeInput"
        ref="promoCodeRef"
        :model-value="modelValue"
        autocomplete="none"
        :hint="configs.hsbc_utm_campaign ? $t('label.hsbc_promo_hint') : null"
        :label="$t('label.promo_code')"
        :loading="loading"
        hide-bottom-space
        outlined
        @update:modelValue="$emit('update:modelValue', $event)"
        @loading="$emit('loading', $event)"
        @show-auth-modal="$emit('show-auth-modal', $event, 'promo_code_check')"
      />
    </q-slide-transition>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  watch,
  onBeforeUnmount,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';

import PromoCode from '~components/PromoCode';
import { useAccountStore } from '~stores/account';
import { useConfigsStore } from '~stores/configs';

const accountStore = useAccountStore();
const configsStore = useConfigsStore();

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'loading',
  'show-auth-modal',
  'update:modelValue',
  'show-promo-code-input',
]);

const showPromoCodeInput = ref(!!props.modelValue);

const { configs } = storeToRefs(configsStore);
const { defaultPartnerPromoCode } = storeToRefs(accountStore);

const defaultPromoCodeText = computed(() => {
  const promoCode = defaultPartnerPromoCode.value;

  if (!promoCode) return '';
  if (promoCode.expired) return t('label.default_promo_code.no_discount');

  const cashback = promoCode.incomes_percentage && accountStore.isPartnerManager;
  return t(`label.default_promo_code.applied${cashback ? '_cashback' : ''}`, {
    code: promoCode.value,
    discount: promoCode.percentage,
    cashback: promoCode.incomes_percentage,
  });
});

watch(() => props.modelValue, (value) => {
  if (value) {
    showPromoCodeInput.value = true;
  }
});

onBeforeUnmount(() => {
  emit('loading', false);
});
</script>
